
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';

import Services from '../components/Services';
import ProductStory from '../components/ProductStory';
import TechAchievements from '../components/TechAchievements';
import Team from '../components/Team';
import UserStories from '../components/UserStories';
import News from '../components/News';
import ContactInfo from '../components/ContactInfo';
import { useDocTitle } from '../hooks/CustomHook';


const Home = () => {
    useDocTitle('江西族迹信息技术有限公司')
    return (
        <>
            <Hero />
            <Intro />
            <Services />
            <ProductStory />
            <TechAchievements />
            <Team />
            <UserStories />
            <News />
            <ContactInfo />
            <Footer />
        </>

    )
}

export default Home;

